module.exports = __webpack_public_path__ + "img/royal hospitals indoor shoot-298.8cba81af.webp";